"use client";

import { FetchInput } from "@/fetch-ui/FetchInput";
import { PartnerFormValues } from "../_logic/partner-form";
import PartnerFieldLabel from "./PartnerFieldLabel";

/** Shape of one required text field on the Partner sign-up form. */
export interface PartnerTextFieldConfig {
  /** Form value key. Also builds the input's id and name. */
  key: Exclude<keyof PartnerFormValues, "partnerType">;
  label: string;
  placeholder: string;
  type: "text" | "email" | "url";
  autoComplete: string;
}

interface PartnerTextFieldProps {
  field: PartnerTextFieldConfig;
  value: string;
  error?: string;
  onChange: (value: string) => void;
}

/**
 * One required, labeled text input on the Partner sign-up form.
 *
 * @param props - See {@link PartnerTextFieldProps}.
 * @returns The label and input, with the error message under the input when there is one.
 */
export default function PartnerTextField({ field, value, error, onChange }: PartnerTextFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <PartnerFieldLabel htmlFor={`partner-${field.key}`} required>
        {field.label}
      </PartnerFieldLabel>
      <FetchInput
        id={`partner-${field.key}`}
        name={field.key}
        type={field.type}
        autoComplete={field.autoComplete}
        placeholder={field.placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        helperText={error}
        required
      />
    </div>
  );
}
